import { useState } from 'react';
import { setShareToken } from '../../services/api.js';
import App from '../../App.jsx';

/**
 * Entry point for the no-signup guest sandbox (`/try`, optionally `/try?session=<id>`).
 *
 * If the landing page uploaded a file it redirects here with ?session=<id>; we
 * register that id as the read token *before* App mounts (via the useState
 * initializer, which runs before child effects) so App's initial load is
 * authorized. With no ?session, App renders the guest home (drop zone + list).
 */
export default function GuestGate() {
  const initialId = new URLSearchParams(window.location.search).get('session');
  useState(() => { if (initialId) setShareToken(initialId); return true; });
  return <App guestMode initialSessionId={initialId || null} currentUser={null} />;
}
